export var VERSION = '2.38.0';
//# sourceMappingURL=version.js.map